import dynamic from 'next/dynamic';
import { PlannerNewEventProps } from './PlannerNewEvent.types';

export const PlannerNewEvent = dynamic<{ model: PlannerNewEventProps }>(() =>
  import('./PlannerNewEvent').then(mod => mod.PlannerNewEvent)
);
